import { HelpTooltip } from '#/components/v2/help-tooltip';
import { useTranslation } from '#/contexts/useTranslation';
import useParamsLocale from '#/data/useParamsLocale';
import useEthereumPendingQueueInfo from '#/data/v2/useEthereumPendingQueueInfo';
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  formatDuration,
  minutesToMilliseconds,
} from 'date-fns';
import { useMemo } from 'react';

export function ActivationQueueLength() {
  const locale = useParamsLocale();
  const { data: pendingQueueData, isLoading } = useEthereumPendingQueueInfo();
  const activeQueueMs = useMemo(() => {
    const activeQueueM = pendingQueueData?.data.data?.activeQueue ?? 0;
    return minutesToMilliseconds(activeQueueM);
  }, [pendingQueueData]);
  const activeQueueText = useMemo(
    () =>
      formatDuration(
        {
          days: differenceInDays(activeQueueMs, 0),
          hours: differenceInHours(activeQueueMs, 0) % 24,
          minutes: differenceInMinutes(activeQueueMs, 0) % 60,
        },
        { locale }
      ),
    [activeQueueMs, locale]
  );
  return isLoading ? '-' : activeQueueText;
}

export function ActivationQueueTip() {
  const translation = useTranslation(
    translation => translation.EthereumStaking
  );
  return (
    <div className="space-y-2">
      <dt className="capitalize text-gray-500 font-normal">
        {translation.ActivationQueueLength}{' '}
        <HelpTooltip content={translation.ActivationQueueLengthHelp} />
      </dt>
      <dd className="text-base text-gray-800 font-medium">
        <ActivationQueueLength />
      </dd>
    </div>
  );
}
